import ReactStrapTable from "components/reactStrapTable";
import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import {
  Button,
  ButtonGroup,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Offcanvas,
  OffcanvasBody,
  Row,
} from "reactstrap";
import columnSelectorIcon from "../../../../assets/icon/column-selector.svg";
import applyIcon from "../../../../assets/icon/apply.svg";
import resetAllIcon from "../../../../assets/icon/resetall.svg";
import SearchButtons from "components/SearchButtons";
import InvOptimizationSmartDeal from "../InvOptimizationSmartDeal";
import CloseIcon from "../../../../assets/icon/chatClose.svg";

const InvOptimizationPage = () => {
  const [columnOpen, setColumnOpen] = useState(false);
  const [updateData, setUpdateData] = useState([]);
  const [data, setData] = useState([]);
  // const [searchData, setSearchData] = useState("");
  const [filterData, setFilterData] = useState(data);
  const [manualOrder, setManualOrder] = useState(false);
  const [rSelected, setRSelected] = useState("off");

  const [check, setCheck] = useState([
    {
      selectall: "",
      recommondation: "",
      drugname: "",
      ndc: "",
      manufacturer: "",
      packagesize: "",
      packageprice: "",
    },
  ]);

  const handleCheck = (e) => {
    const { name, checked } = e.target;
    if (name === "selectall") {
      setCheck({
        selectall: checked,
        recommondation: checked,
        drugname: checked,
        packagesize: checked,
        manufacturer: checked,
        packageprice: checked,
        ndc: checked,
      });
    } else {
      setCheck((prevCheck) => {
        const updatedCheck = { ...prevCheck, [name]: checked };
        const allSelected = Object.values(updatedCheck).every(
          (val) => val === true
        );
        updatedCheck.selectall = allSelected;
        return updatedCheck;
      });
    }
  };

  const apiData = async () => {
    const data = await fetch("https://jsonplaceholder.typicode.com/users");
    const response = await data.json();
    setData(response);
    setFilterData(response);
  };

  useEffect(() => {
    apiData();
  }, []);

  const headerData = [
    {
      id: "1",
      dataField: "recommondation",
      text: "Recommendation",
      show: true,
      width: 150,
      sort: true,
      // cellRenderer: (rowData) => (
      //   <div
      //     onClick={() => setManualOrder(!manualOrder)}
      //     style={{ color: "#212529" }}
      //   >
      //     <a href="#" style={{ color: "#212529" }}>
      //       {rowData.recommondation}
      //     </a>
      //   </div>
      // ),
    },
    {
      id: "2",
      dataField: "drugname",
      text: "Drug Name",
      show: true,
      width: 200,
      sort: true,
    },
    {
      id: "3",
      dataField: "ndc",
      text: "NDC",
      show: true,
      width: 100,
      sort: true,
    },
    {
      id: "4",
      dataField: "manufacturer",
      text: "Manufacturer",
      show: true,
      width: 130,
      sort: true,
    },
    {
      id: "5",
      dataField: "packagesize",
      text: "Package Size",
      show: true,
      sort: true,
      width: 120,
      // cellRenderer: (rowData) => (
      //   <a href="#" style={{ color: "#212529" }}>
      //     {rowData.packagesize}
      //   </a>
      // ),
    },
    {
      id: "6",
      dataField: "packageprice",
      text: "Package Price",
      show: true,
      width: 120,
      sort: true,
    },
    {
      id: "7",
      dataField: "potentialsavings",
      text: "Potential Savings",
      show: true,
      width: 180,
      sort: true,
    },
  ];

  const tableData = [
    {
      recommondation: (
        <div
          className="inv-smart-row"
          onClick={() => setManualOrder(!manualOrder)}
        >
          Smart Deal
        </div>
      ),
      drugname: "Lisinopril 10 MG Tablet",
      ndc: 34981319894,
      manufacturer: "Lupin",
      packagesize: "1000 EA/BOTTLE",
      packageprice: "$ 89.50",
      potentialsavings: "$ 2,539.39/Year",
    },
    {
      recommondation: "Excess Inventory",
      drugname: "Entresto 97/103 MG Tablet",
      ndc: 34981319894,
      manufacturer: "Novartis",
      packagesize: "60 EA/BOTTLE",
      packageprice: "$ 642.15",
      potentialsavings: "$ 3,852.90/Year",
    },
    {
      recommondation: (
        <div
          className="inv-smart-row"
          onClick={() => setManualOrder(!manualOrder)}
        >
          Smart Deal
        </div>
      ),
      drugname: "Eliquis 5 MG Tablet",
      ndc: 34981319896,
      manufacturer: "BMS",
      packagesize: "60 EA/BOTTLE",
      packageprice: "$ 585.25",
      potentialsavings: "$ 4,681.92/Year",
    },
    {
      recommondation: "Store Transfer",
      drugname: "Jardiance 25 MG Tablet",
      ndc: 34981319897,
      manufacturer: "Boehringer",
      packagesize: "30 EA/BOTTLE",
      packageprice: "$ 595.40",
      potentialsavings: "$ 2977.00/Year",
    },
    {
      recommondation: "Excess Inventory",
      drugname: "Metformin 500 MD Tablet",
      ndc: 34981319898,
      manufacturer: "Amneal",
      packagesize: "500 EA/BOTTLE",
      packageprice: "$ 24.95",
      potentialsavings: "$ 1247.50/Year",
    },
    {
      recommondation: (
        <div
          className="inv-smart-row"
          onClick={() => setManualOrder(!manualOrder)}
        >
          Smart Deal
        </div>
      ),
      drugname: "Ozempic 1 MG/0.75ML Pen",
      ndc: 34981319842,
      manufacturer: "Novo Nordisk",
      packagesize: "1 EA/PEN",
      packageprice: "$ 892.95",
      potentialsavings: "$ 3571.80/Year",
    },
    {
      recommondation: "Store Transfer",
      drugname: "Humira Pen 40 MG/0.4ML",
      ndc: 34981319811,
      manufacturer: "Abbvie",
      packagesize: "2 EA/BOX",
      packageprice: "$ 6,235.50",
      potentialsavings: "$ 12471.00/Year",
    },
    {
      recommondation: "Excess Inventory",
      drugname: "Shingrix Vaccine",
      ndc: 34981319844,
      manufacturer: "GSK",
      packagesize: "10 EA/BOX",
      packageprice: "$ 1,850.00",
      potentialsavings: "$ 5550.00/Year",
    },
    {
      recommondation: (
        <div
          className="inv-smart-row"
          onClick={() => setManualOrder(!manualOrder)}
        >
          Smart Deal
        </div>
      ),
      drugname: "Advair HFA Inhaler",
      ndc: 34981319822,
      manufacturer: "GSK",
      packagesize: "1 EA/INH",
      packageprice: "$ 425.75",
      potentialsavings: "$ 2554.50/Year",
    },
    {
      recommondation: "Store Transfer",
      drugname: "Lantus Solostar Pen",
      ndc: 34981319823,
      manufacturer: "Sanofi",
      packagesize: "5 EA/BOX",
      packageprice: "$ 425.95",
      potentialsavings: "$ 2555.70/Year",
    },
  ];

  const filterColumns = () => {
    const columnIndexes = Object.entries(check)
      .filter(([key, value]) => value === true)
      .map(([key]) => {
        if (key === "recommondation") return 0;
        if (key === "drugname") return 1;
        if (key === "ndc") return 2;
        if (key === "manufacturer") return 3;
        if (key === "packagesize") return 4;
        if (key === "packageprice") return 5;
        return -1;
      })
      .filter((index) => index !== -1);
    return headerData.filter((_, index) => columnIndexes.includes(index));
  };

  const filteredColData = filterColumns();
  const totalCount = [
    check.recommondation,
    check.drugname,
    check.ndc,
    check.manufacturer,
    check.packagesize,
    check.packageprice,
  ].filter(Boolean).length;
  const handleSubmit = () => {
    setUpdateData(filteredColData.length > 0 ? filteredColData : headerData);
    setColumnOpen(false);
  };

  const toggleFilter = () => {
    setRSelected((prev) => (prev === "off" ? "on" : "off"));
  };
  return (
    <div
      className=" table-card scroll-table position-relative border-0 p-3 pb-0 layout-alignment rounded bg-white"
      // fixed-height={rowData.length > 0 ? "fixed-height" : "default"}
    >
      <div className="heading-text section-devider-border mb-2 pb-2">
        Inventory Optimization Queue
      </div>

      <Row className="d-flex align-items-center">
        <Col lg={5} className="d-flex " style={{ gap: "12px" }}>
          <SearchButtons
            InSize={250}
            placeHolder={"Search by drug name"}
            data={data}
            setFilterData={setFilterData}
          />
          <Dropdown
            isOpen={columnOpen}
            toggle={() => setColumnOpen(!columnOpen)}
          >
            <DropdownToggle className="clmn">
              <img src={columnSelectorIcon} alt="not available" />
              <span>
                Columns{" "}
                {totalCount > 0 && (
                  <div className="totalcount">{totalCount}</div>
                )}
              </span>
            </DropdownToggle>
            <DropdownMenu className="drop-down-clm">
              <DropdownItem className="dropdownitem-border">
                <Input
                  type="checkbox"
                  name="selectall"
                  value={check.selectall}
                  onChange={handleCheck}
                  checked={check.selectall}
                />
                <span className="m-2">Select All</span>
              </DropdownItem>
              <DropdownItem className="dropdownitem-border">
                <Input
                  type="checkbox"
                  name="recommondation"
                  value={check.recommondation}
                  onChange={handleCheck}
                  checked={check.recommondation}
                />
                <span className="m-2">Recommendation</span>
              </DropdownItem>
              <DropdownItem className="dropdownitem-border">
                <Input
                  type="checkbox"
                  name="drugname"
                  value={check.drugname}
                  onChange={handleCheck}
                  checked={check.drugname}
                />
                <span className="m-2">Drug Name</span>
              </DropdownItem>
              <DropdownItem className="dropdownitem-border">
                <Input
                  type="checkbox"
                  name="manufacturer"
                  value={check.manufacturer}
                  onChange={handleCheck}
                  checked={check.manufacturer}
                />
                <span className="m-2">Manufacturer</span>
              </DropdownItem>
              <DropdownItem className="dropdownitem-border">
                <Input
                  type="checkbox"
                  name="packagesize"
                  value={check.packagesize}
                  onChange={handleCheck}
                  checked={check.packagesize}
                />
                <span className="m-2">NDC</span>
              </DropdownItem>
              <DropdownItem className="dropdownitem-border">
                <Input
                  type="checkbox"
                  name="packageprice"
                  value={check.packageprice}
                  onChange={handleCheck}
                  checked={check.packageprice}
                />
                <span className="m-2">Package Price</span>
              </DropdownItem>

              <DropdownItem className="dropdownitem-border">
                <Input
                  type="checkbox"
                  name="ndc"
                  value={check.ndc}
                  onChange={handleCheck}
                  checked={check.ndc}
                />
                <span className="m-2">Package size</span>
              </DropdownItem>

              <div className="d-flex justify-content-center align-items-center p-2">
                <Button
                  onClick={() =>
                    setCheck({
                      selectall: false,
                      recommondation: false,
                      drugname: false,
                      packageprice: false,
                      manufacturer: false,
                      packagesize: false,
                      ndc: false,
                    })
                  }
                >
                  {" "}
                  <img src={resetAllIcon} alt="" /> Reset All
                </Button>
                <Button
                  color="primary"
                  onChange={handleCheck}
                  onClick={handleSubmit}
                >
                  {" "}
                  <img src={applyIcon} alt="" /> Apply
                </Button>
              </div>
            </DropdownMenu>
          </Dropdown>
        </Col>

        <Col lg={7}>
          <div className="d-flex justify-content-end align-items-center gap-2">
            <span className="f-16 font-weight-600">Filter</span>
            <ButtonGroup className="filter-btn-group">
              <Button
                color="info"
                outline
                onClick={toggleFilter}
                active={rSelected === "off"}
              >
                OFF
              </Button>
              <Button
                color="info"
                outline
                active={rSelected === "on"}
                onClick={toggleFilter}
              >
                ON
              </Button>
            </ButtonGroup>
          </div>
        </Col>
      </Row>

      <div fixed-height={tableData.length > 0 ? "fixed-height" : "default"}>
        <ReactStrapTable
          id="optimization"
          data={tableData}
          columns={updateData.length > 0 ? updateData : headerData}
          height={550}
          width={1200}
          yellowRow={[0, 2, 5, 8]}
        />
      </div>
      <div>
        <Offcanvas
          isOpen={manualOrder}
          toggle={() => setManualOrder(!manualOrder)}
          direction="end"
        >
          <div className="casvas-header p-3 pb-1">
            <div>Smart Deal</div>
            <div
              className="cursor-pointer"
              onClick={() => setManualOrder(!manualOrder)}
            >
              <img src={CloseIcon} />
            </div>
          </div>
          <div className="section-devider-border-popup"></div>

          <OffcanvasBody>
            <InvOptimizationSmartDeal
              closeModal={() => setManualOrder(!manualOrder)}
            />
          </OffcanvasBody>
          <div className="create-manual-footer p-3 m-3">
            <div>
              <Button
                color="primary"
                className="reset"
                onClick={() => setManualOrder(false)}
              >
                Back
              </Button>
            </div>
            <div className="d-flex">
              <Button
                className="back-button"
                onClick={() => setManualOrder(false)}
              >
                Decline
              </Button>
              <Button color="primary" onClick={() => setManualOrder(false)}>
                Accept
              </Button>
            </div>
          </div>
        </Offcanvas>
      </div>
    </div>
  );
};

export default InvOptimizationPage;
